import "./projects.css"
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Projects = (props) => {
  return (
    <div ref={props.projectSection}  className="projects">
          <h3>Projects</h3>
          <ul>
            <li className="project">
              <Link to="https://github.com/vinayak1809/Book-a-Barber" target="_blank">
              <div className="h3">SnipSnap</div>
              <div className="project-info">
                <div className="type-of-pro">
                  <h5>MERN Stack Application</h5> 
                  <FontAwesomeIcon className="re-icon" icon={faArrowRight} />
                </div>
                <p>
                  SnipSnap is a user-friendly application that empowers users to
                  effortlessly schedule salon appointments, complete with
                  integrated payment options. 
                  <span className="br"/> 
                  It also offers a seamless platform
                  for salon owners to register, allowing them to showcase their
                  skills and enhance their business growth.
                </p>
                <ul>
                  <li>MERN</li>
                  <li>bcrypt</li>
                  <li>redux-toolkit</li>
                  <li>redux-persist</li>
                  <li>Cloudinary</li>
                  <li>RazorPay</li>
                </ul>
              </div>
              </Link>
            </li>

            <li className="project">
              <Link to="https://github.com/vinayak1809/Guess-the-image" target="_blank">
              <div className="h3">Guess the image</div>
              <div className="project-info">
                <div className="type-of-pro">
                  <h5>ML-based Full Stack Application</h5>
                  <FontAwesomeIcon className="re-icon" icon={faArrowRight} />
                </div>
                <p>
                  This application is a simple image classification tool built
                  with React, Flask, and TensorFlow. It allows users to upload
                  images, which are then sent to the server for processing using
                  a pre-trained TensorFlow model.
                  <span className="br"/> 
                  The app <span className="highlight"> classifies uploaded
                  images</span> into predefined categories and provides results to the
                  user. Users can explore the world of image classification and
                  gain insights into the underlying machine learning techniques.
                </p>
                <ul>
                  <li>Python</li>
                  <li>Flask</li>
                  <li>React</li>
                  <li>TensorFlow</li>
                  <li>OpenCV</li>
                  <li>Matplotlib</li>
                  <li>NumPy</li>
                  <li>Flask-Cors</li>
                </ul>
              </div>
              </Link>
            </li>

            <li className="project">
              <Link to="https://github.com/vinayak1809/Expense-Tracker" target="_blank">
              <div className="h3">Expense Tracker</div>
              <div className="project-info">
                <div className="type-of-pro">
                  <h5>Full Stack Application</h5>
                  <FontAwesomeIcon className="re-icon" icon={faArrowRight} />
                </div>
                <p>The Expense Tracker is a web-based application built on Express.js and MySQL, designed for managing expenses and earnings while gaining insights into financial habits.
                  <span className="br"/> 
                  In this application users can sign up and log in seamlessly to access their accounts as well as they can change password using <span className="highlight"> sendgrid</span>. Also, it allows users to track both their earnings and expenses conveniently using <span className="highlight">pagination</span>. Additionally, users can upgrade to a premium account with annual or monthly subscription to unlock features like <span className="highlight"> downloadable PDF </span> reports of their credits and expenses.
                </p>
                <ul>
                  <li>JavaScript</li>
                  <li>Node.js</li>
                  <li>Express.js</li>
                  <li>MySQL</li>
                  <li>Sequelize</li>
                  <li>bcrypt</li>
                  <li>Razorpay</li>
                  <li>Sendgrid</li>
                  <li>axios</li>
                </ul>
              </div>
              </Link>
            </li>


            {/* <li className="project">
              <Link to="https://github.com/vinayak1809/Chat-Application"  target="_blank">
              <div className="h3">Group Chat Application</div>
              <div className="project-info">
                <div className="type-of-pro">
                  <h5>Full Stack Application</h5>
                  <FontAwesomeIcon className="re-icon" icon={faArrowRight} />
                </div>
                <p>
                  Group Chat Application is developed using Express.js and MySQL.
                  This web-based platform offers a range of interactive features
                  for inter communication.   
                  <span className="br"/> Users can easily sign up
                  and log in, ensuring hassle-free access. The application
                  supports both one-on-one and group conversations, allowing for
                  meaningful interactions. Users have the ability to create
                  personalized groups, add members, and engage in group chats.
                  Additionally, Group Admins possess privileges to manage and
                  modify group dynamics, ensuring effective communication.
                </p>
                <ul>
                  <li>JavaScript</li>
                  <li>Node.js</li>
                  <li>Express.js</li>
                  <li>MySQL</li>
                  <li>Sequelize</li>
                  <li>bcrypt</li>
                  <li>axios</li>
                </ul>
              </div>
              </Link>
            </li> */}
          </ul>
        </div>
  )
}

export default Projects;